<template>
  <div class="w-90">
    <b-card bg-variant="light">
    <h1 id="jump-to-header">{{heading || "Update"}}</h1>
      <b-tabs
        active-nav-item-class="font-weight-bold text-uppercase text-warning"
        active-tab-class="font-weight-bold text-success"
        content-class="mt-3"
        lazy
      >
        <b-tab title="Settings" active>
          <brand-update :id="id" @gotAttrs="assignAttrs"></brand-update>
        </b-tab>
        <b-tab title="Product Models">
          <product-model-index
            :filtering="filtering_product_model"
            :ams_template="ams_template_product_model"
          ></product-model-index>
        </b-tab>
        <b-tab title="Information">
          <polymorphic-reference-index
            :filtering="filtering_reference"
            :ams_template="ams_template_reference"
          ></polymorphic-reference-index>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import BrandUpdate from './BrandUpdate.vue'
import ProductModelIndex from './ProductModelIndex.vue'
import PolymorphicReferenceIndex from './PolymorphicReferenceIndex.vue'

export default {
  components: {
    BrandUpdate,
    ProductModelIndex,
    PolymorphicReferenceIndex
  },
  props: {
    id: String,
    heading: {
      Type: String
    }
  },
  data () {
    return {
      filtering_product_model: {
        brand_ids: this.id
      },
      ams_template_product_model: {
        type: 'product-models',
        description: undefined,
        attributes: {
          'brand-id': this.id
        }
      },
      filtering_reference: {
        reference_to_type: 'Brand',
        reference_to_id: this.id
      },
      ams_template_reference: {
        type: 'polymorphic-references',
        description: undefined,
        attributes: {
          'reference-to-type': "Brand",
          'reference-to-id': this.id
        }
      },
      attrs: {}
    }
  },
  methods: {
    assignAttrs(attrs) {
      this.attrs = Object.assign( {}, attrs)
    }
  },
  mounted() {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }
}
</script>